var _rect, _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterSearchPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_729",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 30,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.59988,
    width: 29.4667,
    height: 29.4667,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_729)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.59961,
    y: -0.86676,
    width: 35.5333,
    height: 35.5333,
    fill: "#0078CF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8659,
    cy: 8.66667,
    r: 8.66667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2822 8.26807V10.3516H22.998V8.26807H31.2822ZM28.2773 4.98926V13.7881H26.0112V4.98926H28.2773Z",
    fill: "#0078CF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_373_729",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_373_729",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB70lEQVR4nO2cMU4DMRBFtwIOwbVSp4lft3AM4GSQDu6QwAGgN7JEgRAgSGbj+dZ/ktvovdEkC1t4mowxxhhjjDFmdFar1RlwBzwD9Z9nX0q5bZ8xqk8YTeyAoPr5tM8Y1SeMAzenfgl7GdUnjPZ1CwjbjeozZfqqAjej+oTRHhwfcfssD8OSyMcYY4wxRoAj3yfU6D+tsvlMyf4pqFHvGbL5hBG8OfXY9wzZfMJYKoqPo+4TRrYwkvmEkS2MZD5hZAsjmU8Y2cJI5hNGtjCS+YSRLYxkPmFkCyOZTxjZwkjmczDr9fqilHJdStkCb0uHke+05gfgap7n80WGvNlsLoGnBLE1wymlPLaZhG+yh8y3ww7d7PZz0XuDyHvmyEFvEwTVpOc+ctCvCYJqxtNmEzbo3jEkPx40HnTtvYXeaPoPzj8d9B+qf6PxoOupNsUbjQc91KYg4ikfgIinfAAinvIBiHjKByDiKR+AiKd8ACKe8gGIeMoHIOIpH4CIp3wAIp7yAYh4ygcg4ikfgIinfAAinvIBiHjKByDiKR+AiKd8ACKexhhjjDEdWOjanBp9zY6KZ5drcwi8ZkfF80c6b0j96zU7Kp6LXgscGLBT95wUvpL8cr2wiudS1wKf9GFYBDyNMcYYY4wxxhhjpoF4B4VjZQsqzHTMAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearchPlus);
export default __webpack_public_path__ + "static/media/filterSearchPlus.202268df1f0c3e11804481d294dcc0fd.svg";
export { ForwardRef as ReactComponent };